export default {
	props:{
		formTitle:{type:String, default(){ return this.$t('changePasswordForm.formTitle');} },
		backLink: {type:String, default:''},
	},
	data(){
		return {
			formData: {old_password:'', password:'', password2:''},
			formErrors: {},
			successMsg: '',
		}
	},
	watch: {
	},
	computed:{
		actionName(){
			return 'doChangePassword';
		},
		actionUrl(){
			const url = new URL(window.location.href);
			url.searchParams.set('action', this.actionName);
			return url.href;
		},
	},
	methods: {
		gotoBackLink(){
			window.location.href = this.backLink;
		},
		onChangePassword(){
			if(this.formData.password!==this.formData.password2){
				this.$set(this.formErrors, 'password2', this.$t('errors.invalidField'));
			} else {
				this.$set(this.formErrors, 'password2', '');
			}
		},
		onFormSubmit(event){
			this.$refs.chForm.classList.add('submitting');
			this.formErrors = {};
			this.successMsg = '';
			doFetch(this.actionUrl, {}, {'formData':this.formData})
				.then((res) => {
					if (!res || !res.success){
						this.formErrors = res.errors ? res.errors : {'main':'Unknown error!'};
						return;
					}
					this.formData = {old_password:'', password:'', password2:''};
					this.successMsg = res.success_msg;
					this.$emit('success', {success_msg:res.success_msg});
				})
				.catch((error)=>{
					//error
					alert('Unknown error!');
				})
				.finally(()=>{
					this.$refs.chForm.classList.remove('submitting');
				});
		},
	},
	template: `
<form ref="chForm" class="change-password-form client-form" @submit.prevent="onFormSubmit">
  <div v-if="formTitle" class="form-top">{{formTitle}}</div>
  <template v-if="successMsg">
    <div class="form-msg success">
      <i class="qicon-1">check_outline_mini</i>
      <span v-t="successMsg"></span>
    </div>
    <div class="form-bottom">
      <span class="btn small text-transform-none button fill" @click="gotoBackLink">OK</span>
    </div>
  </template>
  <template v-else>
    <div class="form-content">
      <qit-input-text
          class="v1" type="password"
          :label="$t('client.oldPassword')"
          :floating-label="true"
          v-model="formData.old_password"
          :error-msg="formErrors.old_password"
      ></qit-input-text>
      <qit-input-text
          class="v1" type="password"
          :label="$t('client.password')"
          :floating-label="true"
          v-model="formData.password"
          :error-msg="formErrors.password"
          @change="onChangePassword"
      ></qit-input-text>
      <qit-input-text
          class="v1" type="password"
          :label="$t('client.password2')"
          :floating-label="true"
          v-model="formData.password2"
          :error-msg="formErrors.password2"
          @change="onChangePassword"
      ></qit-input-text>
    </div>
    <div class="form-bottom">
      <button class="btn text-transform-none button fill" name="btnSubmit" :value="actionName" v-t="'changePasswordForm.btnSave'"></button>
    </div>
    <div v-if="formErrors.main" class="form-msg errors" v-t="formErrors.main"></div>
	</template>
	<div class="form-submitting-overlay"><div class="spin-loader"></div></div>
</form>
`,
}